const uncutElementVolumePrice = 1500; // €/m³; Definition nach #13044
const cutElementVolumePrice = 1600; // €/m³; Definition nach #13044

export let currentTotalPrice = null;
/*
* Preiskalkulation:
* Für in der Breite ungeschnittene Elemente {{uncutElementVolumePrice}} € pro Kubikmeter.
* Für in der Breite geschnittene Elemente {{uncutElementVolumePrice}} € pro Kubikmeter.
* Die Kubikmeter richten sich dabei aber nach der Größe vor dem Zuschnitt
*/
let prices = {
    'totalPrice': {
        'uncut': 0,
        'cut': 0,
        'combined': 0
    },
    'roofPrice': {
        'uncut': 0,
        'cut': 0,
        'combined': 0
    },
    'floorPrice': {
        'uncut': 0,
        'cut': 0,
        'combined': 0
    },
    'wallsPrice': {
        'uncut': 0,
        'cut': 0,
        'combined': 0
    }
};

export async function recalculatePrice(volumes) {
    let uncutVolume = volumes.total.unCutVolume;
    let cutVolume = volumes.total.cutVolume;

    //Get total price
    let uncutPrice = uncutVolume * uncutElementVolumePrice;
    let cutPrice = cutVolume * cutElementVolumePrice;
    let totalPrice = uncutPrice + cutPrice;

    prices.totalPrice.uncut = uncutPrice;
    prices.totalPrice.cut = cutPrice;
    prices.totalPrice.combined = totalPrice;

    setBuildingCostUIValue(totalPrice);
    currentTotalPrice = totalPrice;

    //Get roof price
    let uncutRoofPrice = volumes.roof.unCutVolume * uncutElementVolumePrice;
    let cutRoofPrice = volumes.roof.cutVolume * cutElementVolumePrice;
    let totalRoofPrice = uncutRoofPrice + cutRoofPrice;

    prices.roofPrice.uncut = uncutRoofPrice;
    prices.roofPrice.cut = cutRoofPrice;
    prices.roofPrice.combined = totalRoofPrice;

    //Get floor price
    let uncutFloorPrice = volumes.floor.unCutVolume * uncutElementVolumePrice;
    let cutFloorPrice = volumes.floor.cutVolume * cutElementVolumePrice;
    let totalFloorPrice = uncutFloorPrice + cutFloorPrice;

    prices.floorPrice.uncut = uncutFloorPrice;
    prices.floorPrice.cut = cutFloorPrice;
    prices.floorPrice.combined = totalFloorPrice;

    //Get walls price
    let uncutWallsPrice = volumes.wallElements.unCutVolume * uncutElementVolumePrice;
    let cutWallsPrice = volumes.wallElements.cutVolume * cutElementVolumePrice;
    let totalWallsPrice = uncutWallsPrice + cutWallsPrice;

    prices.wallsPrice.uncut = uncutWallsPrice;
    prices.wallsPrice.cut = cutWallsPrice;
    prices.wallsPrice.combined = totalWallsPrice;

    return prices;
    // console.log("Total: ", totalPrice, " Roof: ", totalRoofPrice, " Floor: ", totalFloorPrice, " Walls: ", totalWallsPrice);
}


function setBuildingCostUIValue(totalPrice) {
    $('#material-cost-text').find('span').text(totalPrice.toFixed(2) + "€");
}
